// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 482 ? "FluidFramework-HashFallback" : chunkId) + "." + {"176":"a77f8527","377":"0b1f31a1","482":"ea338f41"}[chunkId] + ".js";
};